import type { HomePage } from '../model/HomePage';

export const AutomationExpressUser: HomePage = {
    name: 'AutomationExpress',
    widgets: [ 'RecommendationTemplates', 'Automations', 'Runs' ],
    featureFlag: 'HomePage-AutomationExpress',
    persona: 'AUTOMATION_EXPRESS_USER',
};
